import React, { useEffect, useState } from "react";
import PurpleRing from "../../assests/images/purple-ring-form.svg";
import rightArrow from "../../assests/images/btn-right-arrow.png";
import lockImg from "../../assests/images/form-lock.png";
import checkImg from "../../assests/images/greenCheck.svg";
import { LazyLoadImage } from "react-lazy-load-image-component";
import renderStarImages from "../../hooks/RenderStar";
import { FormRevData } from "../../utils/FormData";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";
import arrowImg from "../../assests/images/progressbar-arrow.png";
import rightImg from "../../assests/images/progressbar-right.png";
import { parsePhoneNumberFromString } from "libphonenumber-js";

const Que1 = () => {
  // hardcoding the responses given by cli
  const date = new Date();
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // months are zero-indexed
  const year = date.getFullYear();

  const formattedDate = `${day}-${month}-${year}`;
  const [hardCodeResponse, setHardCodeResponse] = useState();
  const userSelectedBtn = localStorage.getItem("selectedButtonText");
  useEffect(() => {
    if (userSelectedBtn === "Accident at work") {
      setHardCodeResponse("SCOT EL");
    } else if (userSelectedBtn === "Accident in a public place") {
      setHardCodeResponse("SCOT PL");
    } else if (userSelectedBtn === "Accident on a private place") {
      setHardCodeResponse("SCOT OL");
    } else if (userSelectedBtn === "Road Traffic Accident") {
      setHardCodeResponse("SCOT RTA");
    } else {
      //
    }
  }, [userSelectedBtn]);
  const [checkBox, setCheckBox] = useState(true);
  const handleCheckBox = () => {
    setCheckBox((prevState) => !prevState);
  };
  const [getOtp, setGetOtp] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const [otpValue, setOtpValue] = useState("");
  const [otpButtonText, setOtpButtonText] = useState("SUBMIT");
  const [canResend, setCanResend] = useState(true);
  const [resendText, setResendText] = useState(
    "Didn't Received an OTP? Resend OTP"
  );
  const [verifyButtonText, setVerifyButtonText] = useState("SUBMIT");
  const [disableVerify, setDisableVerify] = useState(false);
  const [counter, setCounter] = useState(0);
  const handleOtpChange = (e) => {
    const value = e.target.value;

    // Allow only numbers and limit to 4 characters
    if (/^\d{0,4}$/.test(value)) {
      setOtpValue(value);
    }
  };
  const [formValue, setFormValue] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
  });
  const [countryCode, setCountryCode] = useState("");

  const FormData = [
    {
      id: 1,
      question: "Did you receive any medical attention?",
      description1:
        "This could have been at the GP, A&E, Walk-in Centre, Physio, Osteo etc. Even ",
      description2: " if you didn't receive any major treatments.",
    },
    {
      id: 2,
      question: "Have you received compensation for this accident already?",
    },
    {
      id: 3,
      question:
        "Good news, you could qualify for compensation. Just 2 more steps to go:",
    },
    {
      id: 4,
      question: `Thanks for that ${formValue?.firstName}, what is your email address?`,
    },
    {
      id: 5,
      question: `Ok ${formValue?.firstName}, please enter your (valid) contact number below so we can get in contact:`,
    },
  ];

  const defaultStyle = {
    background: "linear-gradient(270deg, #08A972 0%, #1B75BB 100%)",
    color: "white",
  };
  const navigate = useNavigate();
  const numbers = [2, 3, 4, 5, 6];
  const data = FormData;
  const revData = FormRevData;
  const [clicked, setClicked] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [responses, setResponses] = useState({});
  const {
    question,
    description1,
    description2,
    id: dataID,
  } = data[currentIndex];
  const { id: revID, userImage, desc, userName } = revData[currentIndex] || {};

  const mergedObject = [{ ...formValue, ...responses }];
  const hasNumbers = /\d/;
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const [phoneNumberFlag, setPhoneNumberFlag] = useState("US");

  const handleClick = (value) => {
    setResponses((prev) => ({
      ...prev,
      [data[currentIndex]?.id]: value,
    }));
  };
  const getButtonStyle = (value) => ({
    backgroundColor: clicked === value ? "#02BA76" : "",
    border: clicked === value ? "none" : "",
    color: clicked === value ? "white" : "",
  });
  const loadIntlTelInput = async () => {
    const phoneInput = document.querySelector("#phone-input");
    if (!phoneInput) return;

    const iti = window.intlTelInput(phoneInput, {
      initialCountry: "gb",
      utilsScript:
        "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.12/js/utils.js",
    });

    // Set initial country code right after initializing the input
    const selectedCountry = iti.getSelectedCountryData();
    setPhoneNumberFlag(selectedCountry?.iso2.toUpperCase());
    setCountryCode(selectedCountry?.dialCode);

    phoneInput.addEventListener("countrychange", function () {
      const selectedCountry = iti.getSelectedCountryData();
      setPhoneNumberFlag(selectedCountry?.iso2.toUpperCase());
      setCountryCode(selectedCountry?.dialCode);
    });
  };

  useEffect(() => {
    if (currentIndex === 4) {
      loadIntlTelInput();
    }
  }, [currentIndex]);

  const [ipv4Address, setIpv4Address] = useState("");
  const [ipv6Address, setIpv6Address] = useState("");
  useEffect(() => {
    const getIpAddress = async () => {
      try {
        const response = await fetch('/.netlify/functions/getIp');
        const data = await response.json();

       
        setIpv4Address(data.ipv4 || 'Unknown IPv4');
        setIpv6Address(data.ipv6 || 'Unknown IPv6');
      } catch (error) {
        console.error('Error fetching IP:', error);
      }
    };

    getIpAddress();
  }, []);
  const questionOne = "How were you injured?";
  const questionThree = "Did you receive any medical attention?";
  const questionFour =
    "Have you received compensation for this accident already?";
  const handleSubmit = async () => {
    try {
      const localData = localStorage?.getItem("FormValues");
      const [dataObject] = JSON.parse(localData);

      const {
        firstName,
        lastName,
        email,
        phone,
        1: response1,
        2: response2,
      } = dataObject;

      let utmParams = {};
      const storedUTMParams = localStorage.getItem("utmParams");

      if (storedUTMParams) {
        const utmParamsArray = JSON.parse(storedUTMParams);
        utmParamsArray.forEach((param) => {
          const key = Object.keys(param)[0];
          utmParams[key] = param[key];
        });
      }
      const jsonData = {
        [questionOne]: hardCodeResponse,
        [questionThree]: response1,
        [questionFour]: response2,
        firstName: firstName,
        lastName: lastName,
        email: email,
        phone: `+${countryCode}${phone}`,
        dateSubmittedOn: formattedDate,
        ipv4: ipv4Address,
        ipv6: ipv6Address,
        acceptedPrivacyPolicy: !checkBox ? "yes" : "no",
        ...utmParams,
      };
      fetch("/.netlify/functions/proxyZapier", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(jsonData),
      })
        .then((response) => response.json())
        .then((result) => {
          navigate("/form/success");
        })
        .catch((error) => {
          toast.error(error.message || "An error occurred");
        });
    } catch (error) {
      toast.error(error.message || "An error occurred");
    }
  };

  const handleContinue = () => {
    let thirdIndexCondition =
      hasNumbers.test(formValue?.firstName) ||
      hasNumbers.test(formValue?.lastName) ||
      formValue?.firstName === "" ||
      formValue?.lastName === "";
    let fourthIndexCondition =
      formValue?.email === "" || !emailPattern.test(formValue?.email);
    if (currentIndex < data?.length - 1) {
      if (currentIndex === 2) {
        if (thirdIndexCondition) {
          toast.error("Please provide valid input");
        } else {
          setCurrentIndex(currentIndex + 1);
        }
      }

      if (currentIndex === 3) {
        if (fourthIndexCondition) {
          toast.error("Please provide valid email");
        } else {
          setCurrentIndex(currentIndex + 1);
        }
      }
    } else {
      if (currentIndex === 4) {
        const phoneNumber = parsePhoneNumberFromString(
          formValue?.phone,
          phoneNumberFlag
        );
        if (!phoneNumber || !phoneNumber.isValid()) {
          toast.error("Please enter a valid phone number");
        }
      }
    }
    setClicked(null);
  };
  const canAttemptOTP = (phoneNumber) => {
    const maxAttempts = 5;
    const resetTime = 15 * 60 * 1000;
    const attemptDataKey = `otp_attempts_${phoneNumber}`;

    const attemptData = JSON.parse(localStorage.getItem(attemptDataKey)) || {
      attempts: 0,
      lastAttemptTime: null,
    };

    const now = Date.now();

    if (
      attemptData.lastAttemptTime &&
      now - attemptData.lastAttemptTime > resetTime
    ) {
      attemptData.attempts = 0;
      attemptData.lastAttemptTime = now;
    }

    if (attemptData.attempts >= maxAttempts) {
      return {
        allowed: false,
        message: "Maximum OTP attempts reached. Try again later.",
      };
    }

    attemptData.attempts += 1;
    attemptData.lastAttemptTime = now;

    localStorage.setItem(attemptDataKey, JSON.stringify(attemptData));

    return { allowed: true };
  };

  const sendOtp = async () => {
    setOtpButtonText("Sending OTP...");
    // Get the phone number and phone number flag from the state
    localStorage.setItem("FormValues", JSON.stringify(mergedObject));
    const localData = localStorage?.getItem("FormValues");
    const [dataObject] = JSON.parse(localData);
    const { phone } = dataObject;

    //making a variable with countryCode for twilio verification
    const fullNumber = `+${countryCode}${phone}`;
    const phoneNumber = parsePhoneNumberFromString(
      formValue?.phone,
      phoneNumberFlag
    );

    if (!phoneNumber || !phoneNumber?.isValid()) {
      toast.error("Please enter a valid phone number");
      setOtpButtonText("SUBMIT");

      return { ok: false }; // Return a response-like object for error cases
    }

    // Check if the user can attempt to request an OTP
    const result = canAttemptOTP(formValue.phone);
    if (!result.allowed) {
      toast.error(result.message);
      setOtpButtonText("SUBMIT");

      return { ok: false }; // Return a response-like object for error cases
    }
    if(!checkBox === true) {
      try {
        const response = await fetch("/.netlify/functions/send-otp", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            phoneNumber: fullNumber, // Send the correct field name
          }),
        });
  
        if (response.ok) {
          setGetOtp(true);
          toast.success("Message Sent Successfully", { toastId: 1 });
        } else {
          setGetOtp(false);
          setOtpButtonText("SUBMIT");
          const errorData = await response.json();
          console.error("Error sending message:", errorData.error);
          toast.error(errorData.error || "An error occurred", { toastId: 2 });
        }
      } catch (error) {
        toast.error(error.message || "An error occurred", { toastId: 2 });
        console.error("Network error:", error);
      } finally {
        setOtpButtonText("SUBMIT");
      }
    } else {
      toast.warn("Please accept the privacy policy", {toastId: "errorToast"});
      setOtpButtonText("SUBMIT");
    }
  };

  const verifyOtp = async () => {
    try {
      setDisableVerify(true);
      setVerifyButtonText("Verifying...");
      localStorage.setItem("FormValues", JSON.stringify(mergedObject));
      const localData = localStorage?.getItem("FormValues");
      const [dataObject] = JSON.parse(localData);
      const { phone } = dataObject;

      //making a variable with countryCode for twilio verification
      const fullNumber = `+${countryCode}${phone}`;
      const response = await fetch("/.netlify/functions/verify-otp", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ phoneNumber: fullNumber, otp: otpValue }),
      });
      if (response.ok) {
        toast.success("OTP verified successfully!", { toastId: 1 });
        setIsVerified(true);
        handleSubmit();
      } else {
        setDisableVerify(false);
        toast.error("An error occured, Try again.", {
          toastId: 2,
        });
        setVerifyButtonText("SUBMIT");
      }
    } catch (error) {
      setDisableVerify(false);
      toast.error(error.message || "An error occured, Try again.", {
        toastId: 2,
      });
    }
  };

  const resendOtp = async () => {
    if (!canResend) {
      toast.warn(`Please wait ${counter} seconds before resending OTP.`, {
        toastId: 1,
      });
      return;
    }

    setDisableVerify(false);
    const phoneNumber = parsePhoneNumberFromString(
      formValue?.phone,
      phoneNumberFlag
    );

    if (!phoneNumber || !phoneNumber?.isValid()) {
      toast.error("Please enter a valid phone number");
      return;
    }

    try {
      //fire the sendOtp function again , for resending the otp
      const response = await sendOtp(); // Await the `sendOtp` function
      if (response?.ok) {
        // Check if the response indicates success
        setOtpValue("");
        setCanResend(false);
        setResendText(`OTP Sent, Please wait...`);
        setCounter(30);

        const interval = setInterval(() => {
          setCounter((prev) => {
            if (prev <= 1) {
              clearInterval(interval);
              setCanResend(true);
              setResendText("Didn't Receive OTP? Resend OTP");
              return 0;
            }
            return prev - 1;
          });
        }, 1000);
      } else {
        // toast.error("Failed to resend OTP. Please try again.", { toastId: 3 });
      }
    } catch (error) {
      toast.error("An error occurred while resending OTP. Please try again.");
      console.error(error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValue(() => ({
      ...formValue,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (clicked) {
      const timer = setTimeout(() => {
        if (
          (currentIndex === 0 && Object.values(responses)[0] === "yes") ||
          (currentIndex === 1 && Object.values(responses)[1] === "no")
        ) {
          setCurrentIndex((prevIndex) => prevIndex + 1);
          setClicked("");
        } else {
          navigate("/form/sorry");
        }
      }, 200);
      return () => clearTimeout(timer);
    }
  }, [clicked, currentIndex, responses, navigate]);

  return (
    <>
      <div className="form-progressBar">
        <div className="number" style={defaultStyle}>
          <img src={rightImg} alt="arrow" />
        </div>
        <img className="arrow" src={arrowImg} alt="arrow" />
        {numbers?.map((num, index) => (
          <React.Fragment key={index}>
            <div
              className="number"
              style={currentIndex >= index ? defaultStyle : {}}
            >
              {currentIndex <= index ? num : <img src={rightImg} alt="" />}
            </div>
            {index < numbers.length - 1 && (
              <img className="arrow" src={arrowImg} alt="arrow" />
            )}
          </React.Fragment>
        ))}
      </div>
      <div className="form-que1" key={dataID}>
        <img src={PurpleRing} alt="" className="ring" />
        <h3>{question}</h3>
        <p>
          {description1} {description2 && <br />}
          <span>{description2}</span>
        </p>
        {currentIndex < 2 && (
          <div className="ansBtn">
            <button
              className="btn"
              value="yes"
              style={getButtonStyle("yes")}
              onClick={(e) => {
                handleClick("yes");
                setClicked("yes");
              }}
            >
              Yes
            </button>
            <button
              value="no"
              className="btn"
              style={getButtonStyle("no")}
              onClick={(e) => {
                handleClick("no");
                setClicked("no");
              }}
            >
              No
            </button>
          </div>
        )}
        {currentIndex === 2 && (
          <div className="fullName">
            <div className="column fullName-col">
              <label htmlFor="firstName">First Name</label>
              <input
                type="text"
                placeholder="Alex"
                name="firstName"
                id="firstName"
                onChange={(e) => {
                  handleChange(e);
                }}
              />
            </div>
            <div className="column fullName-col">
              <label htmlFor="lastName">Last Name</label>
              <input
                type="text"
                placeholder="Smith"
                name="lastName"
                id="lastName"
                onChange={(e) => {
                  handleChange(e);
                }}
              />
            </div>
          </div>
        )}
        {currentIndex === 3 && (
          <div className="email">
            <div className="column">
              <label htmlFor="email">Enter your email address</label>
              <input
                type="text"
                name="email"
                placeholder="Email..."
                id="email"
                onChange={(e) => {
                  handleChange(e);
                }}
              />
            </div>
          </div>
        )}
        {currentIndex === 4 && (
          <div className="phoneNumber">
            <div className="column">
              <label htmlFor="phone-input">Telephone Number *</label>
              <input
                id="phone-input"
                type="tel"
                name="phone"
                onChange={(e) => {
                  handleChange(e);
                }}
              />
            </div>
          </div>
        )}
        {currentIndex !== 0 &&
          currentIndex !== 1 &&
          currentIndex !== 2 &&
          currentIndex !== 3 &&
          getOtp === false && (
            <div className={`continueBtn`}>
              <button
                className={`${getOtp ? "disable" : ""}`}
                onClick={() => {
                  sendOtp();
                }}
              >
                {otpButtonText}
              </button>
            </div>
          )}
        {getOtp === true && (
          <div>
            <div className="phoneNumber">
              <div className="column">
                <label>OTP *</label>
                <input
                  id="otp-input"
                  type="number"
                  name="otp"
                  placeholder="Enter 4 Digit OTP"
                  max={9}
                  maxLength={4}
                  onChange={(e) => {
                    handleOtpChange(e);
                  }}
                  value={otpValue}
                />
                <div className="resend">
                  <div>
                    <button
                      className="resend-otp"
                      onClick={() => {
                        resendOtp();
                      }}
                    >
                      <span className="underline">
                        {counter > 0
                          ? `Resend OTP in ${counter} seconds`
                          : resendText}
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="verifyOtpButton">
              {currentIndex === FormData.length - 1 && !isVerified && (
                <div className="continueBtn">
                  <button
                    className={`${disableVerify ? "disableClass" : ""}`}
                    disabled={disableVerify}
                    onClick={() => {
                      verifyOtp();
                    }}
                  >
                    {verifyButtonText}
                  </button>
                </div>
              )}
            </div>
          </div>
        )}
        {isVerified && (
          <div className="continueBtn">
            <button type="button" onClick={handleSubmit}>
              Submit
            </button>
          </div>
        )}
        {currentIndex !== 0 &&
          currentIndex !== 1 &&
          currentIndex !== FormData.length - 1 && (
            <div className="continueBtn">
              <button type="button" onClick={handleContinue}>
                {currentIndex === FormData.length - 1 ? "Submit" : "Continue"}
                <span>
                  <LazyLoadImage
                    className="arrow"
                    src={rightArrow}
                    alt="arrow"
                  />
                </span>
              </button>
            </div>
          )}
        <div className="lockInfo">
          {currentIndex !== FormData.length - 1 ? (
           <div>
           <img src={lockImg} alt="lock" />
           <p>Your Information is safe & secure</p>
       </div>
          ) : (
            <div>
            <input
                type="checkbox"
                checked={!checkBox}
                id="last-check"
                onChange={handleCheckBox}
              />
              <p>
               <label htmlFor="last-check">
               By clicking 'submit', I consent for the Claim Solutions Scotland
                to process the submitted personal data, including health data,
                to contact me in relation to a potential claim{" "}
                <a
                  href="https://www.claim-solutions-scotland.co.uk/privacy-policy/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  privacy policy.
                </a>
               </label>
              </p>
            </div>
          )}
        </div>
      </div>
      {revID !== undefined && (
        <div className="form-rev">
          <div className="container">
            <div className="review-image">
              <LazyLoadImage src={userImage} alt="user" />
            </div>
            <div className="review-details">
              {renderStarImages(5)}
              <p dangerouslySetInnerHTML={{ __html: desc }}></p>
              <span className="user">
                <span className="userName">{userName}</span>
                <div className="verified">
                  <LazyLoadImage className="check" src={checkImg} alt="check" />
                  <span>Verified customer</span>
                </div>
              </span>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Que1;
